export default "__VITE_ASSET__C0u09HXJ__"